import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: 'mab',
    loadChildren: () =>
      import('./projects/mab/mab.module').then((m) => m.MabModule),
  },
  {
    path: 'dkvform',
    loadChildren: () =>
      import('./projects/dkvergo/dkvergo.module').then((m) => m.DKVErgoModule),
  },
  {
    path: 'ale',
    loadChildren: () =>
      import('./projects/ale/ale.module').then((m) => m.AleModule),
  },
  {
    path: 'agnl',
    loadChildren: () =>
      import('./projects/agnl/agnl.module').then((m) => m.AgnlModule),
  },
  {
    path: 'ag/:id',
    loadComponent: () => import('./projects/ag/ag.component').then(m => m.AgComponent),
    title: 'AG - Data Entry'
  },
  {
    path: 'agaccp/:id',
    loadComponent: () => import('./projects/ag/ag.component').then(m => m.AgComponent),
    title: 'AG - Data Entry'
  },
  {
    path: 'agqual/:id',
    loadComponent: () => import('./projects/ag/ag.component').then(m => m.AgComponent),
    title: 'AG - Data Entry'
  },
  {
    path: 'cora',
    loadChildren: () =>
      import('./projects/cora/cora.module').then((m) => m.CoraModule),
  },
  {
    path: 'rus',
    loadChildren: () =>
      import('./projects/renson/renson.module').then((m) => m.RensonModule),
  },
  {
    path: 'vutg',
    loadChildren: () =>
      import('./projects/vutg/vutg.module').then((m) => m.VutgModule),
  },
  {
    path: 'jeantiteca',
    loadChildren: () =>
      import('./projects/jeantiteca/jeantiteca.module').then(
        (m) => m.JeantitecaModule
      ),
  },
  {
    path: 'q8',
    loadChildren: () =>
      import('./projects/q8/q8.module').then((m) => m.Q8Module),
  },
  {
    path: 'alepluxee',
    loadChildren: () =>
      import('./projects/pluxee/pluxee.module').then((m) => m.PluxeeModule),
  },
  {
    path: 'agnluw',
    loadChildren: () =>
      import('./projects/agnluw/agnluw.module').then((m) => m.AgnluwModule),
  },
  {
    path: 'nnl/:id',
    loadComponent: () => import('./projects/nnl/pages/nnl/nnl.component').then(m => m.NnlComponent),
  },
  {
    path: 'mercedes',
    loadChildren: () =>
      import('./projects/mercedes/mercedes.module').then((m) => m.MercedesModule),
  },
  {
    path: 'aglbroker/:id',
    loadComponent: () => import('./projects/aglife/aglife.component').then(m => m.AglifeComponent),
  },
  {
    path: 'aglbank/:id',
    loadComponent: () => import('./projects/aglife/aglife.component').then(m => m.AglifeComponent),
  },
  {
    path: 'etdmr/:id',
    loadComponent: () => import('./projects/etdmr/etdmr.component').then(m => m.EtdmrComponent),
  },
  {
    path: 'aginvoice/:id',
    loadComponent: () => import('./projects/aginvoice/aginvoice.component').then(m => m.AginvoiceComponent),
  },
  {
    path: 'mabredin/:id',
    loadComponent: () => import('./projects/mabred/pages/mabred/mabred.component').then(m => m.MabredComponent),
    title: 'MAB Redin - Data Entry'
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
